import * as styles from './ToastPopup.css.ts';
import { ToastPopup as Interface } from './types';

const ToastPopup = ({ message }: Interface.Input) => {
  return (
    <div className={styles.container}>
      <div className={styles.toastPopup}>
        <p className={styles.text}>{message}</p>
      </div>
    </div>
  );
};

export default ToastPopup;
